module.exports = __webpack_public_path__ + "static/group5_1-cb6727c63cc4a89eb6b3c25860ae9271.webp";